import classNames from 'classnames';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import ControlOption from './control-option';
import FormGroup from './form-group';
import FormItem from './form-item';

class ControlGroup extends Component {

  render() {
    const {
      children,
      colProps,
      control,
      formGroupProps,
      formItemProps,
      id,
      label,
      labelProps,
      onChange,
      onClick,
      required,
      type,
      className,
      ...otherProps
    } = this.props;

    const formGroupAttributes = {
      ...formGroupProps,
      ...fp.pick(fp.keys(FormGroup.propTypes), otherProps),
      id
    };

    const formItemAttributes = {
      ...formItemProps,
      ...fp.pick(fp.keys(FormItem.propTypes), otherProps),
      type: `${control}-group`
    };

    const controlOptions = React.Children.map(children, (child, index) => {
      const childComponent = child && child.type === ControlOption ?
        React.cloneElement(child, {
          id: `${id}-${index}`,
          type: control,
          name: child.props.name ? child.props.name : fp.camelCase(id),
          required: required,
          onChange: onChange,
          onClick: onClick,
          ...child.props
        }) :
        child;

      return colProps ?
        <Col {...colProps}>
          {childComponent}
        </Col> :
        childComponent;
    });

    const labelText = label !== undefined ? label : fp.startCase(id)
    const validationText = otherProps.validation ? ` (${otherProps.validation})` : ''

    return (
      <FormGroup {...formGroupAttributes}>
        <FormItem {...formItemAttributes}>
          {
            label !== null ?
              <label {...labelProps}>{labelText}{validationText}</label> :
              null
          }
          <div className={classNames(`control-group${type ? `-${type}` : ''}`, className)}>
            {
              colProps ?
                <Row className='sm-gutter'>
                  {controlOptions}
                </Row> :
                controlOptions
            }
          </div>
        </FormItem>
      </FormGroup>
    );
  }
}

ControlGroup.propTypes = {
  colProps: PropTypes.object,
  control: PropTypes.string.isRequired,
  formGroupProps: PropTypes.object,
  formItemProps: PropTypes.object,
  id: PropTypes.string,
  label: PropTypes.node,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  required: PropTypes.bool,
  type: PropTypes.string
};

export default ControlGroup;



// WEBPACK FOOTER //
// ./src/containers/components/control-group.js